import { devices } from '@src/styles/theme';
import styled from 'styled-components';
import StarSvg from '@src/assets/imgs/star.svg';
import BloodHomeSvg from '@src/assets/imgs/bloodHomeIcon.svg';
import BloodLocationSvg from '@src/assets/imgs/bloodLocationIcon.svg';
import DeleteSvg from '@src/assets/imgs/delete.svg';
import { Dispatch } from 'react';
type Props = {
  name: string;
  address: string;
  rating: number;
  isEdit?: boolean;
  resetPlace?: Dispatch<any>;
};

const BloodHomeReview = ({
  name,
  address,
  rating,
  isEdit,
  resetPlace,
}: Props) => {
  const totalStars = 5;
  return isEdit ? (
    <Conatiner isEdit={isEdit}>
      <DeleteButton onClick={resetPlace}>
        <DeleteIcon />
      </DeleteButton>
      <Flex>
        <BloodHomeIcon />
        <Name>{name}</Name>
        <div>
          {[...Array(totalStars)].map((star, i) => {
            const starId = i + 1;
            return (
              <span key={starId}>
                <StarIcon isActive={starId <= rating} />
              </span>
            );
          })}
        </div>
      </Flex>
      <Flex>
        <BloodLocationIcon />
        <Address>{address}</Address>
      </Flex>
    </Conatiner>
  ) : (
    <Conatiner isEdit={isEdit}>
      <Flex>
        <BloodHomeIcon />
        <Name>{name}</Name>
        <div>
          {[...Array(totalStars)].map((star, i) => {
            const starId = i + 1;
            return (
              <span key={starId}>
                <StarIcon isActive={starId <= rating} />
              </span>
            );
          })}
        </div>
      </Flex>
      <Flex>
        <BloodLocationIcon />
        <Address>{address}</Address>
      </Flex>
    </Conatiner>
  );
};

const Conatiner = styled.div<{ isEdit?: boolean }>`
  border: ${({ isEdit, theme }) =>
    isEdit ? `1px solid ${theme.commonColor.gray003}` : 'none'};
  padding: ${({ isEdit }) => (isEdit ? '12px 50px 16px 12px' : 'none')};
  margin-bottom: 20px;
  width: fit-content;
  border-radius: 8px;
  position: relative;
  @media ${devices.tablet} {
    margin-top: 15px;
    padding: 6px 8px 8px 6px;
  }
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const Name = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  margin-left: 15px;
  margin-right: 6px;
  font-family: 'Var';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.42px;
  @media ${devices.tablet} {
    font-size: 14px;
    line-height: 20px;
  }
`;

const Address = styled.div`
  color: ${({ theme }) => theme.commonColor.gray005};
  margin-top: 6px;
  margin-left: 15px;
  font-family: 'Var';
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.6px;
  @media ${devices.tablet} {
    font-size: 12px;
  }
`;

const StarIcon = styled(({ isActive, ...props }) => <StarSvg {...props} />)<{
  isActive: boolean;
}>`
  & > path {
    fill: ${({ theme, isActive }) =>
      isActive ? theme.commonColor.pink004 : theme.commonColor.gray003};
    stroke: ${({ theme, isActive }) =>
      isActive ? theme.commonColor.pink004 : theme.commonColor.gray003};
  }
  width: 20px;
  height: 20px;
  @media ${devices.tablet} {
    width: 16px;
    height: 16px;
  }
`;

const BloodHomeIcon = styled(BloodHomeSvg)`
  width: 24px;
  height: 24px;
  @media ${devices.tablet} {
    width: 16px;
    height: 16px;
  }
`;

const BloodLocationIcon = styled(BloodLocationSvg)`
  width: 24px;
  height: 24px;
  @media ${devices.tablet} {
    width: 16px;
    height: 16px;
  }
`;

const DeleteButton = styled.button`
  position: absolute;
  top: -13px;
  right: -22px;
  padding: 4px 8px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
`;

const DeleteIcon = styled(DeleteSvg)`
  width: 24px;
  height: 24px;
  &:hover {
    color: rgba(0, 0, 0, 0.5);
  }
`;

export default BloodHomeReview;
